import { useState, useEffect } from "react";

import { getReportsData } from "../../services/profileService";

export interface Event {
  id: number;
  title: string;
  datetime: string;
  location_city: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
}

export interface Report {
  admin_comment: string | null;
  comment: string;
  createdAt: string;
  reason: string;
  reported_at_formatted: string;
  reported_type: string;
  reported_type_label: string;
  status: string;
  status_label: string;
  Event: Event;
  reporter: User;
  reportedHost: User | null;
  resolvedBy: User | null;
}

const useReportListLogic = () => {
  const [loading, setLoading] = useState(true);
  const [transactions, setReports] = useState<Report[]>([]);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const res = await getReportsData();
      console.log("Reports data:", res.data.data);
      setReports(res.data.data);
    } catch (err) {
      console.error("Error fetching bookings:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  return {
    transactions,
    loading,
  };
};

export default useReportListLogic;
